module.exports = __webpack_public_path__ + "img/css_sprites-right.f4a2232.png";